import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getGenerationSalesMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetGenerationSalesMasterRequestSchema,
  type GetGenerationSalesMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 発電販売計画マスタ full entity 取得 hook。
 * codes / bgs / plants を含む全フィールドを返す。Edit modal の form 初期値に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetGenerationSalesMaster(
  id: string | undefined,
): UseQueryResult<GetGenerationSalesMasterResponse, ConnectError> {
  return useQuery(
    getGenerationSalesMaster,
    create(GetGenerationSalesMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
